<template>
	<div class="main-container">
		<div id="loading-wrapper">
			<div id="loading"></div>
		</div>
		
	</div>
</template>
<script>
import axios from 'axios';
import Cookies from 'js-cookie'

export default {
	name: 'Login',
	mounted() {
		const code = this.$route.query && this.$route.query.code
		console.log(code)
		if (code) {
			axios.get('https://figcheck.gao-hui.cn/api/wechat/login?code=' + code)
			.then(response => {
				if (response.data && response.data.code && response.data.code === 2000 && response.data.data) {
					const token = response.data.data
					Cookies.set("Access-Token", token, { domain: '.gao-hui.cn' })
					window.location.href = "https://figcheck.gao-hui.cn"
				} else {
					console.log(response)
				}
			})
			.catch(error => {
				console.error("There was an error!", error);
			});
		}
	}
}
</script>
<style scoped>
#loading-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
}
#loading {
	display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1001;
  font-size: 28px;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #C0C4CC;
}
#loading:before {
	content: "";
  position: absolute;
  left: -40px;
  bottom: -40px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 5px solid #C0C4CC;
  border-bottom-color: #2372BC;
  -webkit-animation: spin 0.6s linear infinite;
  -moz-animation: spin 0.6s linear infinite;
  -o-animation: spin 0.6s linear infinite;
  -ms-animation: spin 0.6s linear infinite;
  animation: spin 0.6s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

</style>
